import styles from './privacy-policy.module.scss';
import { WCircularProgress } from '../../components/wrappers/wrapper';
import { useEffect, useState } from 'react';
import dbService from 'services/database.service';

function PrivacyPage() {
  const [html, setHtml] = useState<string | null | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dbService.getContent({ filter: { key: 'privacy_policy' } }).then((res) => {
      const data = res?.[0]?.rich_text || null;
      setHtml(data);
      setLoading(false);
    });
  }, []);

  if (loading || html === undefined) {
    return (
      <div>
        <WCircularProgress size={25} className={styles.content_loading} />
      </div>
    );
  }

  return (
    <>
      {html ? (
        <div className={styles.policy} dangerouslySetInnerHTML={{ __html: html }}></div>
      ) : (
        <div className={styles.error_message}>
          <p>Error: Terms and conditions content is not available. Please try again later.</p>
        </div>
      )}
    </>
  );
}

export default PrivacyPage;
